// extracted by mini-css-extract-plugin
export default {"container":"mNuq2","titleAndContent":"wF6Yg","title":"sf9Sj","subtitle":"arj9T","subtitleText":"dXzjO","content":"yLdYF","extraFooterSpacing":"xY5Bv"};